import React from 'react'
import FormularioAltaFactura from '../../moleculas/FormularioAltaFactura/FormularioAltaFactura'

export default function NuevaFacturaContainer() {
  return (
    <div> 
      <FormularioAltaFactura />
    </div>
  )
}
